export const TARGET_RANGES = 'targetRanges'
